import styled from "styled-components";

export default styled("input")`
  padding: 17px;
  border: none;
  border-radius: 4px;
  margin-bottom: 10px;
`;
